import React from 'react';
import { Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import usePerformanceHeatmap from 'domain/people/employee/performanceReport/shared/PerformanceHeatmap/usePerformanceHeatmap';

const PerformanceHeatmapWeeksHeader = ({ currentMonth }: { currentMonth: string }) => {
  const { getWeeksData } = usePerformanceHeatmap({ currentMonth });
  const heatmapHeaders = getWeeksData();

  return (
    <Box
      component="ul"
      className="performance-heatmap__months"
      sx={{
        gridTemplateColumns: `repeat(${heatmapHeaders.length}, var(--week-square-size)) var(--month-square-gap) auto`,
        gridGap: 'var(--week-square-gap)',
      }}
    >
      {heatmapHeaders.map(header => (
        <li key={uuidv4()}>
          {header.start.date() === header.end.date()
            ? header.end.format('D MMM')
            : `${header.start.date()} - ${header.end.format('D MMM')}`}
        </li>
      ))}
      <li />
      <li>Month</li>
    </Box>
  );
};

export default PerformanceHeatmapWeeksHeader;
